import { render, staticRenderFns } from "./FinetuneSuggestionDetailPolicy.vue?vue&type=template&id=9367f706&scoped=true&"
import script from "./FinetuneSuggestionDetailPolicy.vue?vue&type=script&lang=js&"
export * from "./FinetuneSuggestionDetailPolicy.vue?vue&type=script&lang=js&"
import style0 from "./FinetuneSuggestionDetailPolicy.vue?vue&type=style&index=0&id=9367f706&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9367f706",
  null
  
)

export default component.exports